import { defineMessages } from 'react-intl';

export default defineMessages({
    policyContactDescription: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.Contacts associated with this policy only',
        defaultMessage: 'Contacts associated with this policy only.'
    },
    accountContactsDescription: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.Contacts associated with this account only',
        defaultMessage: 'Contacts associated with this account only.'
    },
    contact: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.Contact',
        defaultMessage: 'Contact'
    },
    role: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.Roles',
        defaultMessage: 'Roles'
    },
    allRoles: {
        id: 'e1p.gateway.contacts.common.views.roles.All Roles',
        defaultMessage: 'All Roles'
    },
    accountHolder: {
        id: 'e1p.gateway.contacts.common.views.roles.AccountHolder',
        defaultMessage: 'Account Holder'
    },
    additionalInsured: {
        id: 'e1p.gateway.contacts.common.views.roles.AdditionalInsured',
        defaultMessage: 'Additional Insured'
    },
    additionalInterest: {
        id: 'e1p.gateway.contacts.common.views.roles.AdditionalInterest',
        defaultMessage: 'Additional Interest'
    },
    driver: {
        id: 'e1p.gateway.contacts.common.views.roles.Driver',
        defaultMessage: 'Driver'
    },
    laborClient: {
        id: 'e1p.gateway.contacts.common.views.roles.LaborClient',
        defaultMessage: 'Labor Client'
    },
    laborContractor: {
        id: 'e1p.gateway.contacts.common.views.roles.LaborContractor',
        defaultMessage: 'Labor Contractor'
    },
    namedInsured: {
        id: 'e1p.gateway.contacts.common.views.roles.NamedInsured',
        defaultMessage: 'Named Insured'
    },
    ownerOrOfficer: {
        id: 'e1p.gateway.contacts.common.views.roles.OwnerOfficer',
        defaultMessage: 'Owner/Officer'
    },
    policyAddlInsured: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicyAddlInsured',
        defaultMessage: 'Additional Insured'
    },
    policyAddlInterest: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicyAddlInterest',
        defaultMessage: 'Additional Interest'
    },
    policyAddlNamedInsured: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicyAddlNamedInsured',
        defaultMessage: 'Additional Named Insured'
    },
    policyBillingContact: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicyBillingContact',
        defaultMessage: 'Billing Contact'
    },
    policyDriver: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicyDriver',
        defaultMessage: 'Driver'
    },
    policyLaborClient: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicyLaborClient',
        defaultMessage: 'Labor Client'
    },
    policyLaborContractor: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicyLaborContractor',
        defaultMessage: 'Labor Contractor'
    },
    policyOwnerOfficer: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicyOwnerOfficer',
        defaultMessage: 'Owner/Officer'
    },
    policyPriNamedInsured: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicyPriNamedInsured',
        defaultMessage: 'Primary Named Insured'
    },
    policySecNamedInsured: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.PolicySecNamedInsured',
        defaultMessage: 'Secondary Named Insured'
    },
    wC7PolicyContactRole: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.WC7PolicyContactRole',
        defaultMessage: 'Policy Contact Role'
    },
    wC7PolicyLaborClient: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.WC7PolicyLaborClient',
        defaultMessage: 'Policy Labor Client'
    },
    wC7PolicyLaborContractor: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.WC7PolicyLaborContractor',
        defaultMessage: 'Policy Labor Contractor'
    },
    wC7ExcludedOwnerOfficer: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.WC7ExcludedOwnerOfficer',
        defaultMessage: 'Excluded Owner Officer'
    },
    wC7IncludedOwnerOfficer: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.WC7IncludedOwnerOfficer',
        defaultMessage: 'Included Owner Officer'
    },
    wC7LaborContact: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.WC7LaborContact',
        defaultMessage: 'Labor Contact'
    },
    wC7PolicyOwnerOfficer: {
        id: 'e1p.gateway.contacts.common.views.policy.roles.WC7PolicyOwnerOfficer',
        defaultMessage: 'Policy Owner Officer'
    },
    involvedWith: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.Involved With',
        defaultMessage: 'Involved With'
    },
    activePolicies: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.Policies',
        defaultMessage: 'Active Policies'
    },
    activePolicy: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.Policy',
        defaultMessage: 'Active Policy'
    },
    account: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.Account',
        defaultMessage: 'Account'
    },
    relatedBy: {
        id: 'e1p.gateway.contacts.AccountRelationshipType.Related by:',
        defaultMessage: 'Related by:'
    },
    relationshipTypeAll: {
        id: 'e1p.gateway.contacts.AccountRelationshipType.All',
        defaultMessage: 'All'
    },
    child: {
        id: 'e1p.gateway.contacts.AccountRelationshipType.typekey.parent',
        defaultMessage: 'Parent'
    },
    parent: {
        id: 'e1p.gateway.contacts.AccountRelationshipType.typekey.child',
        defaultMessage: 'Child'
    },
    commonOwner: {
        id: 'e1p.gateway.contacts.AccountRelationshipType.typekey.commonowner',
        defaultMessage: 'Common Ownership'
    },
    commonContact: {
        id: 'e1p.gateway.contacts.AccountRelationshipType.Common Contact',
        defaultMessage: 'Common Contact'
    },
    allRelationshipDescription: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.RelationshipDesc.$all',
        defaultMessage: 'These contacts are on accounts that are related in any way to the account: {accountName} {accountNumber}.'
    },
    childRelationshipDescription: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.RelationshipDesc.child',
        defaultMessage: 'These contacts are on accounts that are parents of the account: {accountName} {accountNumber}.'
    },
    parentRelationshipDescription: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.RelationshipDesc.parent',
        defaultMessage: 'These contacts are on accounts that are children of the account: {accountName} {accountNumber}.'
    },
    commonOwnerRelationshipDescription: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.RelationshipDesc.commonowner',
        defaultMessage: 'These contacts are on accounts that share common ownership with the account: {accountName} {accountNumber}.'
    },
    commonContactRelationshipDescription: {
        id: 'e1p.gateway.contacts.common.components.Contacts.AccountContacts.RelationshipDesc.$common',
        defaultMessage: 'These contacts are on accounts that have a contact in common with the account: {accountName} {accountNumber}. Each contact in common is indicated as such.'
    }
});
